import {Component, Input, OnInit} from '@angular/core';
import {Organization} from '../../../../model/Organization';
import {StartupService} from '../../../service-ui/startup.service';
import {OrganizationService} from '../../../service-data/organization.service';
import {CatalogService} from '../../../service-data/catalog.service';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.css']
})
export class OrganizationComponent implements OnInit {
  @Input() organization: Organization;
  @Input() allowAdminRescue: boolean;
  editableOrganization: Organization;
  editOrganization = false;
  private originalSnapshot: string;

  constructor(public startupService: StartupService, private organizationService: OrganizationService, public catalogService: CatalogService) {
    this.editOrganization = false;
  }

  get hasChanges(): boolean {
    if (!this.editableOrganization) {
      return false;
    }
    return JSON.stringify(this.editableOrganization) !== this.originalSnapshot;
  }

  ngOnInit() {
    this.editOrganization = false;
    this.editableOrganization = new Organization(this.organization);
    this.originalSnapshot = JSON.stringify(this.editableOrganization);
  }

  edit() {
    this.editableOrganization = new Organization(this.organization);
    this.originalSnapshot = JSON.stringify(this.editableOrganization);
    this.editOrganization = true;
  }

  cancel() {
    this.editOrganization = false;
    this.editableOrganization = new Organization(this.organization);
    this.originalSnapshot = JSON.stringify(this.editableOrganization);
  }

  save() {
    this.organizationService.updateOrganization(this.editableOrganization).subscribe(changedOrganization => {
      console.log('Organization was changed.');
    });
    this.editOrganization = false;
    this.organizationService.reset();
  }

  revokeMicroInventory(organization: Organization) {
    this.editableOrganization.microInventory = 'INACTIVE';
  }

  grantMicroInventory(organization: Organization) {
    this.editableOrganization.microInventory = 'ACTIVE';
  }
}

